import { DEFAULT_DAILY } from "@/lib/constants";
import DailyLifetimeStats from "./DailyLifetimeStats";
import ShopPanel from "../panels/ShopPanel";
import InfoPanel from "../panels/InfoPanel";
import DailyChallengeSummary from "./DailyChallengeSummary";
import { useRouter } from "next/router";
import { mapPlaylistItems } from "@/lib/utils";
import StaffPanel from "../panels/StaffPanel";
import TrendingPanel from "../panels/TrendingPanel";
import PanelButton, { TYPE_BACK } from "../panels/PanelButton";
import PanelGrid from "@/components/panels/PanelGrid";
import Disclaimer from "../panels/Disclaimer";
import LiveModePanel from '@/components/panels/LiveModePanel';

const Summary = ({ data = DEFAULT_DAILY, onShare, uid }) => {
  const router = useRouter();
  
  return (<>
    <PanelGrid className={`min-w-[360px] xl:mb-0`}>
      <div className="grid gap-2 mb-2 order-first xl:col-span-3">
        <DailyChallengeSummary data={data} onShare={onShare} />			
      </div>
      <div className="grid gap-2 mb-2 order-4 xl:order-2 xl:col-span-4">
        <div className={'hidden xl:flex'}>
          <DailyLifetimeStats data={data}/>
        </div>
        <ShopPanel />
        <InfoPanel className={'xl:hidden inline-flex'}/>
      </div>
      <div className="grid gap-2 mb-2 xl:order-3 xl:col-span-3">
        <LiveModePanel />
        <StaffPanel />
        <TrendingPanel />
        <InfoPanel className={'hidden xl:inline-flex'}/>
      </div>
    </PanelGrid>
    <div className={`mb-4 md:mb-6 xl:mb-auto xl:mt-4`}>
      <PanelButton type={TYPE_BACK} onClick={() => router.push("/")} />
    </div>
    <Disclaimer/>
  </>);
};

export default Summary;
